import React from 'react';

function UserIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M11.9987 0.333496C5.5587 0.333496 0.332031 5.56016 0.332031 12.0002C0.332031 18.4402 5.5587 23.6668 11.9987 23.6668C18.4387 23.6668 23.6654 18.4402 23.6654 12.0002C23.6654 5.56016 18.4387 0.333496 11.9987 0.333496ZM6.24703 19.3268C6.7487 18.2768 9.80537 17.2502 11.9987 17.2502C14.192 17.2502 17.2604 18.2768 17.7504 19.3268C16.1637 20.5868 14.1687 21.3335 11.9987 21.3335C9.8287 21.3335 7.8337 20.5868 6.24703 19.3268ZM19.4187 17.6352C17.7504 15.6052 13.702 14.9168 11.9987 14.9168C10.2954 14.9168 6.24703 15.6052 4.5787 17.6352C3.3887 16.0718 2.66536 14.1235 2.66536 12.0002C2.66536 6.85516 6.8537 2.66683 11.9987 2.66683C17.1437 2.66683 21.332 6.85516 21.332 12.0002C21.332 14.1235 20.6087 16.0718 19.4187 17.6352ZM11.9987 5.00016C9.73536 5.00016 7.91537 6.82016 7.91537 9.0835C7.91537 11.3468 9.73536 13.1668 11.9987 13.1668C14.262 13.1668 16.082 11.3468 16.082 9.0835C16.082 6.82016 14.262 5.00016 11.9987 5.00016ZM11.9987 10.8335C11.0304 10.8335 10.2487 10.0518 10.2487 9.0835C10.2487 8.11516 11.0304 7.3335 11.9987 7.3335C12.967 7.3335 13.7487 8.11516 13.7487 9.0835C13.7487 10.0518 12.967 10.8335 11.9987 10.8335Z'
				fill='#545454'
			></path>
		</svg>
	);
}

export default UserIcon;
